import React, { Component } from 'react';

import './App.css';

import Header from '../../containers/Header';

class OnwrApp extends Component {
  render() {
    return (
      <>
        <Header />
      </>
    );
  }
}

export default OnwrApp;
